import { NullAdapter } from './adapters/NullAdapter'

// Strategy facade: the public API stays sync-looking, while heavy providers
// such as Sentry are loaded only when observability is initialized.
export class ObservabilityEngine {
  #adapter
  #adapterFactory
  #adapterPromise = null
  #config = null

  constructor(adapterFactory = () => new NullAdapter()) {
    this.#adapterFactory = adapterFactory
    this.#adapter = new NullAdapter()
  }

  async #resolveAdapter() {
    if (this.#adapterPromise) return this.#adapterPromise

    this.#adapterPromise = Promise.resolve()
      .then(() => this.#adapterFactory())
      .then((adapter) => {
        this.#adapter = adapter || new NullAdapter()
        if (this.#config) this.#adapter.init(this.#config)
        return this.#adapter
      })
      .catch(() => {
        this.#adapter = new NullAdapter()
        return this.#adapter
      })

    return this.#adapterPromise
  }

  #withAdapter(callback) {
    this.#resolveAdapter().then(callback).catch(() => {})
  }

  init(config) {
    this.#config = config
    this.#withAdapter((adapter) => adapter.init(config))
  }

  captureException(error, context) {
    this.#withAdapter((adapter) => adapter.captureException(error, context))
  }

  captureMessage(message, level = 'info', context) {
    this.#withAdapter((adapter) => adapter.captureMessage(message, level, context))
  }

  setUser(user) {
    this.#withAdapter((adapter) => adapter.setUser(user))
  }

  addBreadcrumb(breadcrumb) {
    this.#withAdapter((adapter) => adapter.addBreadcrumb(breadcrumb))
  }
}
